import { Component } from '@angular/core';
import { GuidService } from 'core-lib';

@Component({
  selector: 'cli-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  private title: string;
  private guid: string;

  constructor(private guidService: GuidService) {
      this.title = 'client-web';
      this.guid = guidService.getGuid();
  }
}
